import { makeAutoObservable, runInAction } from "mobx";
import ApiData from "./ApiData";
import ApiDataAnalitic from "./ApiDataAnalitic";
import Memory from "./Memory";
import stateFilter from "../state/state.filter";
import FilterData from "./FilterData";
import pLimit from "p-limit";
import { normalizeTotals } from "../utils/eventTotalsSaUtils";
import { compareSoftVersionForReport } from "../utils/softVersionCompareUtils";
import {
  getSoftwareTypeFromSession,
  matchesSoftwareTypeMode,
} from "../utils/softVersionClientTypeUtils";

class report {
  // Переменные фильтров

  soft_version = [];
  soft_version_error = [];
  serialisation_list = null;
  creatingProcessSerialisationFlag = false;
  creatingCompliteSerialisationFlag = false;
  flagVersion = true;
  versionReportSourcesReady = false;
  versionReportCacheKey = null;
  versionReportWarmupPromise = null;
  loadingCount = 0;
  state_sort_func_name = {
    flag: null,
    func: null,
    name: null,
  };
  serialisation_list_original = [];
  serialisation_list = [];

  constructor() {
    makeAutoObservable(this);
  }

  resetSessionCaches = () => {
    runInAction(() => {
      this.soft_version = [];
      this.soft_version_error = [];
      this.serialisation_list = null;
      this.serialisation_list_original = [];
      this.serialisation_list = [];
      this.creatingProcessSerialisationFlag = false;
      this.creatingCompliteSerialisationFlag = false;
      this.flagVersion = true;
      this.loadingCount = 0;
      this.versionReportSourcesReady = false;
      this.versionReportCacheKey = null;
      this.versionReportWarmupPromise = null;
    });
  };

  buildVersionReportCacheKey = (valueVersion) =>
    `${valueVersion}|${Memory.version_reduction}|${stateFilter.filter_active_client}|${stateFilter.filter_active_server}|${getSoftwareTypeFromSession()}`;

  ensureVersionReportSources = async () => {
    if (this.versionReportSourcesReady) {
      return;
    }
    await ApiData.getAllSoft();
    await ApiData.getAllLicensings();
    runInAction(() => {
      this.versionReportSourcesReady = true;
    });
  };

  computeSoftVersionReport = async (valueVersion) => {
    try {
      const cacheKey = this.buildVersionReportCacheKey(valueVersion);
      if (
        cacheKey === this.versionReportCacheKey &&
        this.soft_version.length > 0
      ) {
        runInAction(() => {
          this.flagVersion = false;
        });
        return;
      }
      runInAction(() => {
        this.flagVersion = true;
      });
      const nextRows = [];
      await this.hendlerValidLic(nextRows, valueVersion);
      runInAction(() => {
        this.soft_version = nextRows;
        this.versionReportCacheKey = cacheKey;
      });
    } catch (e) {
      console.error(e);
    }
  };

  warmVersionReportAtStartup = () => {
    if (this.versionReportWarmupPromise) {
      return this.versionReportWarmupPromise;
    }
    this.versionReportWarmupPromise = (async () => {
      try {
        await this.ensureVersionReportSources();
        await this.computeSoftVersionReport("1.0.4.6");
      } catch (e) {
        console.error(e);
      }
    })();
    return this.versionReportWarmupPromise;
  };

  setParameter = (name, value) => {
    this[`${name}`] = value;
  };

  hendlerValidLic = async (array, version) => {
    try {
      if (version === undefined) {
        return;
      }
      const mode = Memory.version_reduction;
      const tempArray = ApiData.soft_all_data.filter((s) => {
        if (!s.software_version) {
          return false;
        }
        if (
          !compareSoftVersionForReport(
            s.software_version,
            version,
            mode,
          )
        ) {
          return false;
        }
        return matchesSoftwareTypeMode(s, getSoftwareTypeFromSession());
      });
      const licensingByClientId = new Map(
        ApiData.licensing_all.map((l) => [l.software_client_id, l]),
      );
      const byInn = new Map();
      for (const el of tempArray) {
        const license = licensingByClientId.get(el.client_id);
        if (!license) {
          continue;
        }
        // если активирована кнопка только оборудование с лицензией
        if (stateFilter.filter_active_client && !license.is_activ) {
          continue;
        }
        // если активирована кнопка только сервер
        if (
          stateFilter.filter_active_server &&
          el.software_client_rel?.type !== "SRV"
        ) {
          continue;
        }
        const inn = el.company_rel?.inn;
        if (inn == null) {
          continue;
        }
        const existing = byInn.get(inn);
        if (existing) {
          existing.count += 1;
        } else {
          byInn.set(inn, {
            inn,
            name_company: el.company_rel.name_company,
            count: 1,
          });
        }
      }
      for (const row of byInn.values()) {
        array.push(row);
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.flagVersion = false;
    }
  };

  reportSoftVersion = async (valueVersion) => {
    try {
      await this.ensureVersionReportSources();
      await this.computeSoftVersionReport(valueVersion);
    } catch (e) {
      console.error(e);
    }
  };

  /** @deprecated Для сводного отчёта на вкладке «Сериализация» используйте reportEventTotalsSa. Оставлено для AlertData. */
  reportSerialisation = async (_data, begin, end) => {
    this.loadingCount = 0;
    this.creatingProcessSerialisationFlag = true;
    this.creatingCompliteSerialisationFlag = false;
    const limit = pLimit(1);
    // Параллельная обработка всех компаний
    const companyPromises = _data.map((c, index) =>
      limit(async () => {
        // Добавляем задержку перед началом обработки каждой компании
        if (index > 0) {
          await new Promise((resolve) => setTimeout(resolve, 10000)); //  задержка
        }
        try {
          const verify = await ApiDataAnalitic.fetchLabelStatisticSa({
            companyId: c.id,
            filterdate: [begin, end],
            step: "y",
            event: "v",
          });
          this.setParameter("loadingCount", this.loadingCount + 1);
          const defect = await ApiDataAnalitic.fetchLabelStatisticSa({
            companyId: c.id,
            filterdate: [begin, end],
            step: "y",
            event: "d",
          });
          // ]);

          if (!verify || !defect) return null;
          const countVerify = verify.production.reduce(
            (total, item) =>
              total + item.data.reduce((sum, curr) => sum + curr.count, 0),
            0,
          );

          const countDefect = defect.production.reduce(
            (total, item) =>
              total + item.data.reduce((sum, curr) => sum + curr.count, 0),
            0,
          );
          return {
            name_company: c.name_company,
            inn: c.inn,
            verify: countVerify,
            defect: countDefect,
            percent: Number(
              (
                (100 / (countVerify !== 0 ? countVerify : 1)) *
                countDefect
              ).toFixed(2) !== "NaN"
                ? (
                    (100 / (countVerify !== 0 ? countVerify : 1)) *
                    countDefect
                  ).toFixed(2)
                : 0,
            ),
            nameVerifyRU: "Верифицировано",
            nameDefectRU: "Отбракованно",
          };
        } catch (error) {
          console.error(`Error processing company ${c.id}:`, error);
          return null;
        }
      }),
    );

    // Ожидаем завершения всех промисов
    const results = await Promise.all(companyPromises);
    this.serialisation_list_original = results.filter((item) => item !== null);
    FilterData.sortAllAB(this.serialisation_list, "verify");
    this.serialisation_list = this.serialisation_list_original.filter(
      (item) => item.verify !== 0,
    );
    runInAction(() => {
      this.creatingCompliteSerialisationFlag = true;
    });
    return results.filter((item) => item !== null && item.verify !== 0);
  };

  reportEventTotalsSa = async (_data, begin, end) => {
    this.loadingCount = 0;
    this.creatingProcessSerialisationFlag = true;
    this.creatingCompliteSerialisationFlag = false;
    this.serialisation_list_original = [];
    this.serialisation_list = [];
    try {
      const companyList = Array.isArray(_data) ? _data : [];
      const payload = await ApiData.fetchEventTotalsSa({
        filterdate: [begin, end],
      });
      if (!payload) {
        runInAction(() => {
          this.creatingProcessSerialisationFlag = false;
          this.creatingCompliteSerialisationFlag = false;
        });
        return [];
      }
      const catalog = companyList.length ? companyList : ApiData.companys ?? [];
      const byId = new Map(catalog.map((c) => [Number(c.id), c]));
      const rows = payload.companies.map((row) => {
        const meta = byId.get(Number(row.company_id));
        const totals = normalizeTotals(row.totals);
        return {
          name_company: meta?.name_company ?? "—",
          inn: meta?.inn ?? "—",
          verify: totals.VERIFY,
          incident: totals.INCIDENT,
          defect: totals.DEFECT,
          print: totals.PRINT,
        };
      });
      runInAction(() => {
        this.serialisation_list_original = rows;
        this.serialisation_list = rows.filter((item) => item.verify !== 0);
        this.creatingProcessSerialisationFlag = true;
        this.creatingCompliteSerialisationFlag = true;
      });
      return rows;
    } catch (e) {
      console.error(e);
      runInAction(() => {
        this.creatingProcessSerialisationFlag = false;
        this.creatingCompliteSerialisationFlag = false;
      });
      return [];
    }
  };

  visibleAllList = (hiddenZiro) => {
    if (!this.serialisation_list_original) return;
    this.serialisation_list = hiddenZiro
      ? this.serialisation_list_original.filter((item) => item.verify !== 0)
      : this.serialisation_list_original;
    this.resultFilter(
      this.state_sort_func_name.flag,
      this.state_sort_func_name.func,
      this.state_sort_func_name.name,
    );
  };

  resultFilter = (flag, func, name) => {
    if (flag) {
      this.state_sort_func_name = {
        ...this.state_sort_func_name,
        flag: flag,
        func: func,
        name: name,
      };
      this.serialisation_list = func(this.serialisation_list, name);
    }
  };

  sortSerialisation = (sortTable) => {
    for (const field of ["verify", "incident", "defect", "print"]) {
      this.resultFilter(
        sortTable[`${field}AB`],
        FilterData.sortAllAB,
        field,
      );
      this.resultFilter(
        sortTable[`${field}BA`],
        FilterData.sortAllBA,
        field,
      );
    }
  };
}

export default new report();
